var map = {
	"./symbol_0.png": 14688,
	"./symbol_1.png": 69513,
	"./symbol_2.png": 78802,
	"./symbol_3.png": 93019,
	"./symbol_4.png": 11364,
	"./symbol_5.png": 51309,
	"./symbol_6.png": 69686,
	"./symbol_7.png": 66015,
	"./symbol_8.png": 83752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47155;